import { db } from "./config";

/**
 * A fundi's replies to their own reviews — written from the fundi's own app
 * (FundiUpdated/Database/reviews.js's `submitReply`) into
 * `FundiAppUsers/{fundiId}/ReviewReplies/{reviewId}` in this same project
 * (rekebishafundi-94607), since that's the only Firebase project a fundi is actually
 * authenticated against. `reviewId` matches the corresponding `handymanReviews` doc id
 * one-to-one (from RekebishaMembers/reviews.js), so merging a reply onto its review is
 * a plain lookup by id.
 */

const toMillis = (value) => (typeof value?.toMillis === "function" ? value.toMillis() : 0);

/** { [reviewId]: { text, updatedAtMillis } } for every review this fundi replied to. */
export const fetchReplies = async (fundiId) => {
  if (!fundiId) return {};

  const snapshot = await db
    .collection("FundiAppUsers")
    .doc(fundiId)
    .collection("ReviewReplies")
    .get();

  return snapshot.docs.reduce((replies, entry) => {
    const data = entry.data();
    replies[entry.id] = {
      text: data.text || "",
      updatedAtMillis: toMillis(data.updatedAt),
    };
    return replies;
  }, {});
};
